__turbopack_context__.v({
  "icon": "Navigation-module-scss-module__oHbnhG__icon",
  "menuOpen": "Navigation-module-scss-module__oHbnhG__menuOpen",
  "mobileMenuButton": "Navigation-module-scss-module__oHbnhG__mobileMenuButton",
  "navigationButtons": "Navigation-module-scss-module__oHbnhG__navigationButtons",
  "offset": "Navigation-module-scss-module__oHbnhG__offset",
  "open": "Navigation-module-scss-module__oHbnhG__open",
  "wrapper": "Navigation-module-scss-module__oHbnhG__wrapper",
});
